import React from 'react';
import MarkerGauge from '@splunk/dashboard-visualizations/MarkerGauge';

export default () => (
    <MarkerGauge
        options={{
            ranges: [
                {
                    from: -10,
                    to: 50,
                    value: '#ff7152',
                },
            ],
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'count' }],
                    columns: [['36']],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
